<template lang="pug">
.integrations.container.text-left
  integration-detail
  .row
    h4.text-center Integrations
  .row.cards-row(v-if='!providers.Github && !viewedAchievements.addIntegrationClicked')
    .overlay.d-flex.align-items-center.justify-content-center.text-center(
        @click='clickAddIntegration()'
      )
      // @TODO: component
      .card-wrap
        img.compass(src='../../assets/nav/compass.svg')
        h3 Integrate Your Workflow!
        p
          | Integrate other apps to make the most of your progress.
          | Grow your sprite, track your activity, and get rewarded for things you do!
        .btn-green(@click='clickAddIntegration()') Let's Go!
  .row.cards-row.justify-content-center(v-else)
    .col-lg-2
      .card(:class="{'active': providers.Habitica}", @click='displayIntegration(providers.Habitica)')
        img(src='../../assets/habitica.svg')
        .integrated(v-if='providers.Habitica') Integrated
        .not-integrated(v-else) Integrate
    .col-lg-2
      .card(:class="{'active': providers.Github}", @click='displayIntegration(providers.Github)')
        img(src='../../assets/github.svg')
        .integrated(v-if='providers.Github') Integrated
        .not-integrated(v-else, @click='loginGithub()') Integrate
    //.col-lg-2
      .card(@click='loginTodoist()', :class="{'active': providers.Todoist}") Todoist
    .col-lg-2
      .card More coming soon
</template>

<style lang="scss" scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0;
  }

  h4 {
    margin-top: .5em;
    margin-bottom: 1em;
    width: 100%;
    font-size: 24px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: 3px;
    text-align: center;
    text-transform: uppercase;
    color: #6c6d69;
  }

  .integrations {
    position: relative;
    margin-top: 4em;
    margin-bottom: 4em;
  }

  .card {
    padding: 1.5em .5em;
  }

  .cards-row {
    border-radius: 4px;
    padding: 1.5em 1em;
    position: relative;

    .overlay {
      width: 100%;
      height: 100%;
      border-radius: 16px;
      z-index: 1;
    }

    .btn-white {
      border-radius: 999px;
      border: none;
      background-color: #ffffff;
      padding: 1rem 1.5rem;
      font-size: 14px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.43;
      letter-spacing: 1px;
      text-align: center;
      color: #9bc75a;
      text-transform: uppercase;
    }

    .btn-white:hover {
      opacity: 0.8;
      cursor: pointer;
    }

    .card {
      border-radius: 8px;
      border: 8px solid #fff;
      height: 100%;
      font-weight: bold;
      box-shadow: 0 2px 2px 0 rgba(31, 31, 31, 0.12), 0 0 2px 0 rgba(31, 31, 31, 0.12);
      transition: box-shadow ease-in .15s;
    }

    .card:hover {
      cursor: pointer;
      box-shadow: 0 4px 8px 0 rgba(31, 31, 31, 0.16), 0 4px 8px 0 rgba(31, 31, 31, 0.24);
    }

    .card.active {
      background: #fff;
      color: #000;
      opacity: 1;
    }
  }

  .not-integrated, .integrated {
    font-size: 12px;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: 0.5px;
    text-align: center;
    text-transform: uppercase;
    margin-top: 1em;
  }

  .not-integrated {
    border-radius: 999px;
    background-color: #9bc75a;
    font-weight: 800;
    color: #f7f8f6;
    padding: .5em .3em;
  }

  .not-integrated:hover {
    cursor: pointer;
  }

  .integrated {
    font-weight: bold;
    color: #9bc75a;
    padding: .5em .3em;
  }
</style>

<script>
import axios from 'axios';
import uuidv4 from 'uuid/v4';
import oauth from '../../mixins/oauth';

import IntegrationDetail from './IntegrationDetail';

export default {
  mixins: [oauth],
  components: {
    IntegrationDetail,
  },
  data() {
    return {
      githubRepos: [],
      addIntegrationClicked: false,
    };
  },
  computed: {
    providers() {
      return this.$store.state.integrations;
    },
    viewedAchievements() {
      return this.$store.state.viewedAchievements;
    },
  },
  methods: {
    clickAddIntegration() {
      this.$store.commit('setAchievement', { achievement: 'addIntegrationClicked' });
    },
    loginGithub() {
      if (this.providers.Github) return;
      const redirectURl = window.location.href;
      //  30d458bd2397a8e325f6'; // 71c29a3b6b32b66d88ea
      const githubUrl = 'https://github.com/login/oauth/authorize?client_id=30d458bd2397a8e325f6&scope=user:email%20read:org';
      this.openSocialLoginWindow(githubUrl, redirectURl);
    },
    loginTodoist() {
      if (this.providers.Todoist) return;
      const redirectURl = window.location.href;
      const CLIENT_ID = '2b03c3cee007484d848c4ebb3f9c11ba';
      const STATE = uuidv4();
      const url = `https://todoist.com/oauth/authorize?client_id=${CLIENT_ID}&scope=data:read,data:delete&state=${STATE}`;
      this.openSocialLoginWindow(url, redirectURl, 'todoist');
    },
    async selectGithubRepo() {
      const token = axios.defaults.headers.common.Authorization;
      // @TODO: How to temporarily remove token. Maybe we just use multiple instances in a library
      delete axios.defaults.headers.common.Authorization;
      const { accessToken } = this.providers.Github[0];

      const instance = axios.create({
        baseURL: 'https://api.github.com',
        headers: {},
      });

      const repos = await instance.get(`/user/repos?access_token=${accessToken}`);
      this.githubRepos = repos.data;

      axios.defaults.headers.common.Authorization = token;
    },
    async addGithubWebhook(repository) {
      const owner = repository.owner.login;
      const repo = repository.name;
      await axios.post('/webhooks/github', {
        owner,
        repo,
      });
    },
    displayIntegration(integration) {
      if (!integration) return;
      this.$root.$emit('show-integration-detail', { integration });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/integration/IntegrationBox.vue